import React from "react";
import { formatPrice } from "../../checkout/utils/pricing";
import { S3_URL_PRODUCTS } from "../../../shared/utils/constants";

// Building blocks shared by Order Details and Track Order. Styles: my-orders.css + order-details.css.

export const hasValue = (value) => value !== null && value !== undefined && value !== "";

/** Address card; `address` = { firstName, lastName, address1, address2, city, state, postCode, country, phone, email }. */
export const AddressCard = ({ title, address }) => {
  if (!address) return null;
  const name = [address.firstName, address.lastName].filter(hasValue).join(" ");
  const street = [address.address1, address.address2].filter(hasValue).join(", ");
  const area = [address.city, address.state, address.postCode].filter(hasValue).join(", ");
  if (!name && !street && !area) return null;
  return (
    <section className="od-card">
      <h2 className="od-card__title">{title}</h2>
      <div className="od-address">
        {name && <p className="od-address__name">{name}</p>}
        {street && <p>{street}</p>}
        {area && <p>{area}</p>}
        {hasValue(address.country) && <p>{address.country}</p>}
        {hasValue(address.phone) && (
          <p className="od-address__contact">
            <i className="ph ph-phone" aria-hidden="true" /> {address.phone}
          </p>
        )}
        {hasValue(address.email) && (
          <p className="od-address__contact">
            <i className="ph ph-envelope-simple" aria-hidden="true" /> {address.email}
          </p>
        )}
      </div>
    </section>
  );
};

/** One amount line in the payment summary; hidden when the API has no value for it. */
export const SummaryRow = ({ label, value, currency, strong }) =>
  hasValue(value) ? (
    <div className={`od-summary__row${strong ? " od-summary__row--total" : ""}`}>
      <span>{label}</span>
      <span>
        {currency} {formatPrice(value)}
      </span>
    </div>
  ) : null;

/** Items card; `items` = [{ key, name, image, quantity, price }]. */
export const OrderItemsCard = ({ items, currency }) => (
  <section className="od-card">
    <h2 className="od-card__title">
      Items <span className="od-card__count">{items.length}</span>
    </h2>
    <ul className="od-items">
      {items.map((item) => (
        <li key={item.key} className="order-item">
          <span className="order-item__thumb">
            {item.image ? (
              <img src={`${S3_URL_PRODUCTS}${item.image}`} alt="" loading="lazy" />
            ) : (
              <i className="ph ph-package" />
            )}
          </span>
          <span className="order-item__name">{item.name}</span>
          <span className="order-item__meta">
            {hasValue(item.quantity) && <span className="order-item__qty">Qty {item.quantity}</span>}
            {hasValue(item.price) && (
              <span className="order-item__price">
                {currency} {formatPrice(item.price)}
              </span>
            )}
          </span>
        </li>
      ))}
    </ul>
  </section>
);
